import { FluxErrorCodes } from "@buildwithflux/constants";
import { FluxBaseError } from "../flux_error";
export class PcbLayoutNodeDataIntegrityError extends FluxBaseError {
    constructor(message, options = {}) {
        super(FluxErrorCodes.PcbLayoutNodeDataIntegrityError, message, options);
    }
}
//# sourceMappingURL=error.js.map